export default {
      id: "icon-hours-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-hours",
      toString: function () {
        return this.url;
      }
    }